import Parse from "parse";
import Toasted from "vue-toasted";
import Vue from "vue";
import { FETCH_DASHBOARDS } from "./actions.type";
import { FETCH_DASHBOARDS_START, FETCH_DASHBOARDS_END } from "./mutations.type";
import store from "./index";

Vue.use(Toasted);

const state = {
  home: {},
  isLoadingDashboards: true
};

const getters = {
  home(homeState) {
    return homeState.home;
  },
  isLoadingDashboards(homeState) {
    return homeState.isLoadingDashboards;
  }
};

const actions = {
  [FETCH_DASHBOARDS]({ commit }) {
    const user = store.state.auth.user;
    console.log(`${FETCH_DASHBOARDS} - auth.user: ${JSON.stringify(user)}`);
    commit(FETCH_DASHBOARDS_START);
    return new Promise((resolve, reject) => {
      const timeStart = new Date().getTime();

      Parse.Cloud.run("home:loadDashboardsV2", { user })
        .then(result => {
          const timeEnd = new Date().getTime();
          // console.log(
          //   `${FETCH_DASHBOARDS} - result: ${JSON.stringify(result)}`
          // );
          console.log(
            `${FETCH_DASHBOARDS} - duration (server): ${result.duration}`
          );
          console.log(
            `${FETCH_DASHBOARDS} - duration (client): ${timeEnd - timeStart}`
          );
          commit(FETCH_DASHBOARDS_END, result);
          resolve();
        })
        .catch(e => {
          console.log(`error loading dashboards: ${e.message}`);
          Vue.toasted.error(`error loading dashboards: ${e.message}`, {
            duration: 5000
          });
          reject();
        });
    });
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_DASHBOARDS_START](homeState) {
    homeState.isLoadingDashboards = true;
  },
  [FETCH_DASHBOARDS_END](homeState, result) {
    homeState.home = result;
    homeState.isLoadingDashboards = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
